import React from 'react'
import { Switch, Route, AuthRoute, NotFound } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import AdminLandingPage from './pages/AdminLandingPage'
import PlaceReports from './pages/PlaceReportsPage/PlaceReportsPage'
import EditorHandbookPage from './pages/EditorHandbookPage/EditorHandbookPage'
import PlaceLearnToRankPage from './pages/PlaceLearnToRankPage/PlaceLearnToRankPage'

const ActivityApp = React.lazy(() => import('./pages/ActivityPage/ActivityPage'))
const ManagerPage = React.lazy(() => import('./pages/ManagerPage/ManagerPage'))

function App() {
  return (
    <ErrorBoundary>
      <Switch>
        <AuthRoute exact path="/manager/" component={ManagerPage} />
        <AuthRoute exact path="/monitor/" component={ActivityApp} />
        <Route exact path="/place-reports/" component={PlaceReports} />
        <AuthRoute exact path="/" component={AdminLandingPage} />
        <AuthRoute path="/editor-handbook/" component={EditorHandbookPage} />
        <AuthRoute exact path="/place-learn-to-rank/" component={PlaceLearnToRankPage} />
        <Route component={NotFound} />
      </Switch>
    </ErrorBoundary>
  )
}
export default App
